import { render } from "./TableOrdersDashboard.vue?vue&type=template&id=31502fe1"
import script from "./TableOrdersDashboard.vue?vue&type=script&lang=js"
export * from "./TableOrdersDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__